module.exports = __webpack_public_path__ + "static/media/umts.feaf0764.png";